import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BannerComponent } from './components/banner/banner.component';
import { CouponListComponent } from './components/coupon-list/coupon-list.component';
import { CouponSkeletonComponent } from './components/coupon-skeleton/coupon-skeleton.component';
import { CouponComponent } from './components/coupon/coupon.component';
import { FaqComponent } from './components/faq/faq.component';
import { FilterModalComponent } from './components/filter-modal/filter-modal.component';
import { FooterComponent } from './components/footer/footer.component';
import { ModalStarterFreeComponent } from './components/modal-starter-free/modal-starter-free.component';
import { NavMobileComponent } from './components/nav-mobile/nav-mobile.component';
import { NavComponent } from './components/nav/nav.component';
import { PartnerBannerComponent } from './components/partner-banner/partner-banner.component';
import { BadgeComponent } from './lib/badge/badge.component';
import { BtnCheckComponent } from './lib/btn-check/btn-check.component';
import { DropdownComponent } from './lib/dropdown/dropdown.component';
import { SearchComponent } from './lib/search/search.component';
import { MenuWrapperComponent } from './wrappers/menu-wrapper/menu-wrapper.component';
import { HammerModule } from '@angular/platform-browser';

@NgModule({
  declarations: [
    BadgeComponent,
    MenuWrapperComponent,
    DropdownComponent,
    NavComponent,
    FooterComponent,
    CouponComponent,
    CouponListComponent,
    FaqComponent,
    BannerComponent,
    PartnerBannerComponent,
    NavMobileComponent,
    SearchComponent,
    FilterModalComponent,
    BtnCheckComponent,
    ModalStarterFreeComponent,
    CouponSkeletonComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgOptimizedImage,
    FormsModule,
    HammerModule,
  ],
  exports: [
    CouponComponent,
    MenuWrapperComponent,
    BadgeComponent,
    CouponListComponent,
    FaqComponent,
    BannerComponent,
    PartnerBannerComponent,
    SearchComponent,
    FilterModalComponent,
    BtnCheckComponent,
    ModalStarterFreeComponent,
  ],
})
export class SharedModule {}
